import * as React from 'react';
import { Button } from 'primereact/button';
import { Alert } from 'reactstrap';
import CollaudoBot from './Bot';

function YesNoQuestion(props) {
    const yes = props.step.value && props.step.value.result;
    const completed = props.step.value && props.step.value.completed;

    return (
        <div>
            <Alert
                color={!completed ? 'info' : yes ? 'success' : 'danger'}
                title={props.question}>
                <div>
                    {completed && <div>{yes ? props.yesLabel : props.noLabel}</div>}
                    {!completed && (
                        <div>
                            <Button
                                label={props.yesLabel}
                                icon="pi pi-check"
                                style={{ marginRight: '5px' }}
                                onClick={() => {
                                    props.triggerNextStep({
                                        trigger: props.yesTrigger,
                                        value: {
                                            question: props.question,
                                            result: true,
                                            completed: true
                                        }
                                    });
                                }}
                                className="p-button-success p-button-rounded"
                            />

                            <Button
                                label={props.noLabel}
                                icon="pi pi-times"
                                style={{ marginRight: '5px' }}
                                onClick={() => {
                                    props.triggerNextStep({
                                        trigger: props.noTrigger,
                                        value: {
                                            question: props.question,
                                            result: false,
                                            completed: true
                                        }
                                    });
                                }}
                                className="p-button-danger p-button-rounded"
                            />
                        </div>
                    )}
                </div>
            </Alert>
        </div>
    );
}

export { CollaudoBot, YesNoQuestion };
